import axios from 'axios'
import { CONFIGS } from '../configs'

export default {
  order_by_prefix(data) {
    return axios.post(CONFIGS.API_SERVER + '/api/reports/order_by_prefix', data)
  },
  publication_price() {
    return axios.get(CONFIGS.API_SERVER + '/api/reports/publication_prices')
  },
  paid_orders(start, end) {
    return axios.post(CONFIGS.API_SERVER + '/api/reports/paid_orders', {'start': start, 'end': end})
  },
  expedition_list(start, end, client) {
    return axios.post(CONFIGS.API_SERVER + '/api/reports/expedition_list', {'start': start, 'end': end, 'client': client})
  },
  expired_signatures(start, end) {
    return axios.post(CONFIGS.API_SERVER + '/api/reports/expired_signatures', {'start': start, 'end': end})
  },
}
